const REQUEST_STATUS = {
  '0_NEW': {
    key: '0_NEW',
    label: 'Awaiting Submission',
    color: 'var(--status_new)',
    next_step_label: 'Submit Order',
    next_step_key: '1_SUBMITTED',
    icon: 'rocket-slant',
  },
  '1_SUBMITTED': {
    key: '1_SUBMITTED',
    label: 'Awaiting Approval',
    color: 'var(--status_submitted)',
    next_step_label: 'Approve Order',
    next_step_key: '2_APPROVED',
    icon: 'tick-circle',
  },
  '2_APPROVED': {
    key: '2_APPROVED',
    label: 'Awaiting Transaction Creation',
    color: 'var(--status_approved)',
    next_step_label: 'Create Transaction',
    next_step_key: '3_TRANSACTION_CREATED',
    icon: 'dollar',
  },
  '3_TRANSACTION_CREATED': {
    key: '3_TRANSACTION_CREATED',
    label: 'Awaiting Purchase',
    color: 'var(--status_transaction_created)',
    next_step_label: 'Confirm Purchase',
    next_step_key: '4_PURCHASED',
    icon: 'shopping-cart',
  },
  '4_PURCHASED': {
    key: '4_PURCHASED',
    label: 'Awaiting Receipt',
    color: 'var(--status_purchased)',
    next_step_label: 'Mark Order Received',
    next_step_key: '5_RECEIVED',
    icon: 'form',
  },
  '5_RECEIVED': {
    key: '5_RECEIVED',
    label: 'Received',
    color: 'var(--status_received)',
  },
  '6_REJECTED': {
    key: '6_REJECTED',
    label: 'Request Not Approved',
    color: 'var(--status_rejected)',
    icon: 'rocket-slant',
    next_step_label: 'Resubmit Order',
    next_step_key: '1_SUBMITTED',
  },
};

const REQUEST_STATUS_KEYS = {
  NEW: '0_NEW',
  SUBMITTED: '1_SUBMITTED',
  APPROVED: '2_APPROVED',
  TRANSACTION_CREATED: '3_TRANSACTION_CREATED',
  PURCHASED: '4_PURCHASED',
  RECEIVED: '5_RECEIVED',
  REJECTED: '6_REJECTED',
};

const SHIPPING_SPEED = {
  '0_STANDARD': 'Standard',
  '1_TWO_DAY': 'Two Day',
  '2_NEXT_DAY': 'Next Day',
};

const NOTE_UPDATE_ACTIONS = {
  CREATED: 'created',
  UPDATED: 'updated',
  DELETED: 'deleted',
};

const getStatusObject = (statusKey) => {
  return REQUEST_STATUS[statusKey] || { key: statusKey, label: statusKey };
};

module.exports = {
  REQUEST_STATUS,
  REQUEST_STATUS_KEYS,
  SHIPPING_SPEED,
  NOTE_UPDATE_ACTIONS,
  getStatusObject,
};
